import script from "./ConnectedAppsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedAppsCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueButton from "@/components/neue/NeueButton.vue";
import SettingCard from "@/components/settings/SettingCard.vue";
import SettingRow from "@/components/settings/SettingRow.vue";
script.components = Object.assign({}, { NeueButton, SettingCard, SettingRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueButton, SettingCard, SettingRow }, script.__o.components);}